import { Alert } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'

export const OrderTransportDuplicateContainerWarning = observer(() => {
  const { t } = useTranslate()

  return (
    <Alert severity='warning'>
      {t(
        'anOrderForThisContainerAlreadyExistsUnderTheSelectedVesselVisit',
        'An order for this container already exists under the selected vessel visit.',
      )}
    </Alert>
  )
})
